import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "@mui/material";

// UI Components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Services
import AddonService from "services/addon-service";

function AddonPaymentFail() {
    const navigate = useNavigate();
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [validFail, setValidFail] = useState(false);
    const [loading, setLoading] = useState(true);

    // Guard against React 18 Strict Mode double-invocation
    const effectRan = useRef(false);

    useEffect(() => {
        if (effectRan.current) return;
        effectRan.current = true;

        const checkBillingFailure = async () => {
            try {
                const response = await AddonService.getLatestAddonBilling();
                const billing = response.billing;

                if (billing && billing.status === "Fail" && billing.display_result === true) {
                    setValidFail(true);
                    setShowSnackbar(true);

                    await AddonService.updateAddonBilling(billing.session_id, { display_result: false });
                } else {
                    console.warn("⚠️ Addon billing record invalid for fail page. Redirecting...");
                    navigate("/profile");
                }
            } catch (err) {
                console.error("❌ Error checking addon billing on fail page:", err);
                navigate("/profile");
            } finally {
                setLoading(false);
            }
        };

        checkBillingFailure();
    }, [navigate]);

    if (loading) return null;
    if (!validFail) return null;

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="60vh"
            >
                <Card
                    sx={{
                        p: 4,
                        maxWidth: 460,
                        width: "90%",
                        borderRadius: "16px",
                        textAlign: "center",
                        backgroundColor: "rgba(255,255,255,0.95)", // Glass-ish
                        boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                    }}
                >
                    <MDTypography variant="h1" sx={{ mb: 1, fontSize: "4rem !important" }}>
                        🚫
                    </MDTypography>

                    <MDTypography variant="h4" fontWeight="bold" gutterBottom color="error">
                        Add-on Purchase Failed
                    </MDTypography>

                    <MDTypography variant="body2" color="text" sx={{ mb: 3 }}>
                        Unfortunately, your add-on purchase could not be processed.
                        Please try again or contact support.
                    </MDTypography>

                    <MDButton
                        variant="contained"
                        color="accent"
                        size="large"
                        onClick={() => navigate("/profile")}
                        sx={{ px: 4, py: 1.5, fontWeight: 600, width: "100%" }}
                    >
                        Return to Profile
                    </MDButton>
                </Card>
            </MDBox>

            <Snackbar
                open={showSnackbar}
                autoHideDuration={6000}
                onClose={() => setShowSnackbar(false)}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    onClose={() => setShowSnackbar(false)}
                    severity="error"
                    sx={{ width: "100%" }}
                >
                    Add-on purchase failed. Please try again.
                </Alert>
            </Snackbar>
            <Footer />
        </DashboardLayout>
    );
}

export default AddonPaymentFail;
